import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgb-leaderboard-v2-nav',
  templateUrl: './leaderboard-v2-nav.component.html',
  styleUrl: './leaderboard-v2-nav.component.scss',
})
export class LeaderboardV2NavComponent {
  @Input() routeLink: string;
  @Input() isRulesEnabled: boolean = false;
}
